
import { City } from "@/models/City";
import { MapOptions } from "@/models/Map";
import DateHelper from "@/utils/DateHelper";
import StringHelper from "@/utils/StringHelper";
import { Component, Vue } from "vue-property-decorator";
import Map from "../Base/Map.vue";
import { Validations } from "vuelidate-property-decorators";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

@Component({
  components: { Map },
})
class AddCity extends Vue {
  displayName = "";
  place: any = {};
  errorMessage = "";
  lat = 0;
  lng = 0;

  get getSlugifyName(): string {
    return StringHelper.Slugify(this.displayName);
  }

  get centerPoint(): any {
    return { latitude: this.lat, longitude: this.lng };
  }

  get getCities(): City[] {
    return this.$store.state.cityStore.city;
  }

  created(): void {
    this.$v.$touch();
  }

  cancel(): void {
    this.lat = 0;
    this.lng = 0;
    this.$bvModal.hide("team-modal-add-city");
  }
  async saveCity(): Promise<void> {
    if (this.getCities.find((x) => x.slug === this.getSlugifyName)) {
      this.errorMessage = "An city with the same slug already exists.";
      this.$bvModal.show("modal-sm");
    } else {
      if (this.displayName.length > 0 && /[a-z]/i.test(this.displayName)) {
        const place = await this.getCountryFromLatLng(
          this.place.latitude,
          this.place.longitude
        );
        const countryCode = this.getCountry(place);
        if (place !== "" && countryCode !== "") {
          const city: City = {
            slug: this.getSlugifyName,
            name: { en: this.displayName },
            centre_point: {
              latitude: this.place.latitude,
              longitude: this.place.longitude,
            },
            locations: {
              centre_point: {
                slug: "centre_point",
                name: { en: "centre_point" },
                lat_long: {
                  latitude: this.place.latitude,
                  longitude: this.place.longitude,
                },
              },
            },
            country: countryCode,
            game_count: 0,
            is_edit: false,
          };
          this.$store
            .dispatch("cityStore/insertNewCity", city)
            .then((results) => {
              if (results === "success") {
                this.place = null;

                this.lat = 0;
                this.lng = 0;
                this.displayName = "";
                this.$bvModal.hide("team-modal-add-city");
              } else {
                //display erorr
                console.log(results);
              }
            });
        } else {
          this.errorMessage =
            "Issue: No place selected with relevant country. If you are on a country, please move closer to a place";
          this.$bvModal.show("modal-sm");
        }
      } else {
        this.$bvModal.show("modal-sm");
        this.errorMessage =
          "Please make sure the display name is not empty and contains at least one letter";
      }
    }
  }
  get getCityMarkerPoints(): MapOptions[] {
    var arr = [];
    var cityCentreMarker: MapOptions = {
      position: {
        lat: this.lat,
        lng: this.lng,
      },
      title: "MapMarker",
      draggable: true,
      clickable: false,
      zIndex: 1000,
      slug: "",
    };
    arr.push(cityCentreMarker);
    return arr;
  }
  mapData(place: any): void {
    this.place = place;
    this.lat = place.latitude;
    this.lng = place.longitude;
  }

  getCountry(place: any): string {
    if (place === "") {
      return "";
    } else {
      try {
        for (var i = 0; i < place.results[0].address_components.length; i++) {
          if (
            place.results[0].address_components[i].types.indexOf("country") !=
            -1
          ) {
            return place.results[0].address_components[i].short_name;
          }
        }
        return "";
      } catch (error) {
        console.log(error);
        return "";
      }
    }
  }

  async getCountryFromLatLng(lat: number, long: number): Promise<any> {
    const data = await DateHelper.getCountry(lat, long);
    return data;
  }

  @Validations()
  validations = {
    displayName: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(160),
    },
  };
}

export default AddCity;
